export const API_URL_DEV = 'https://dsz_api.test/';
//export const API_URL_DEV = 'https://dsz-api.customer.digitalgoal.de/';
export const API_URL_PRODUCTION = 'https://api.deutsches-schilddruesenzentrum.de/';
export const COOKIE_PREFIX_DEV = 'dev';
export const COOKIE_PREFIX_PRODUCTION = 'prod';
